"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var modules_1 = require("./modules");
exports.default = {
    // App
    APP_REVIEW_INSIGHTS: __spreadArray([
        {
            entitlement: "B2B2024_AppReviewInsights",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    // Locations
    LOCATIONS_REVIEWS_BY_CITY: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentLocationsReviewsByCityTable"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    // Location details
    LOCATION_DETAILS_TOP_TOPICS: __spreadArray([
        {
            entitlement: "B2B2024_ComponentLocationDetailsTopTopics",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    LOCATION_DETAILS_EXPORT: __spreadArray([
        {
            entitlement: "B2B2024_ComponentLocationDetailsReviewExport",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    // Topics
    TOPICS: __spreadArray([
        {
            entitlement: ["B2B2024_PageTopics"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    TOPICS_TABLE: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTopicsTable"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    TOPICS_HEATMAP: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTopicsHeatmap"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    TOPICS_ADD_CUSTOM_TOPIC: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTopicsAddCustomTopic"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    // Topic details
    TOPIC_DETAIL_RELATED_TOPICS: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTopicDetailsRelatedTopics"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    TOPIC_DETAIL_TOP_FIVE_CITIES_COUNTRIES: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTopicDetailsTopFiveCitiesCountries"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    TOPIC_DETAIL_REVIEW_EXPORT: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTopicReviewExport"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    // Trustscore forecast
    TRUSTSCORE_FORECAST_CUSTOM_FORECASTS: __spreadArray([
        {
            entitlement: ["B2B2024_ComponentTrustscoreForecastCustomForecasts"],
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    LEGACY_COMPETITORS_PAGE: __spreadArray([], __read(modules_1.legacyReviewInsightsModuleAccess), false),
};
//# sourceMappingURL=review-insights.js.map